/* Camp Tricky: samler svarene fra tilmeldingen i kundens tags, så de kan ses og filtreres under Kunder i Shopify. */
(function () {
  function clean(value) {
    return String(value || '')
      .replace(/[,<>]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 80);
  }

  function initSignup(form) {
    if (form.dataset.ctReady) return;
    form.dataset.ctReady = 'true';

    form.addEventListener('submit', function () {
      var base = form.getAttribute('data-base-tag') || 'venteliste';
      var tags = [clean(base)];
      var pairs = [
        ['bil', form.querySelector('[data-ct="car"]')],
        ['postnr', form.querySelector('[data-ct="zip"]')],
        ['tlf', form.querySelector('[data-ct="phone"]')]
      ];
      pairs.forEach(function (pair) {
        if (pair[1] && clean(pair[1].value)) tags.push(pair[0] + ': ' + clean(pair[1].value));
      });
      var rack = form.querySelector('input[name="ct_rack"]:checked');
      if (rack) tags.push('tagbøjler: ' + clean(rack.value).toLowerCase());
      var when = form.querySelector('input[name="ct_when"]:checked');
      if (when) tags.push('brug: ' + clean(when.value).toLowerCase());

      var hidden = form.querySelector('input[name="contact[tags]"]');
      if (hidden) hidden.value = tags.join(', ');
    });
  }

  function init() {
    document.querySelectorAll('form[data-ct-signup]').forEach(initSignup);

    // Efter indsendelse genindlæser Shopify siden. Scroll ned til formularen, så kunden ser takkebeskeden.
    if (document.querySelector('[data-ct-scroll]') || /customer_posted=true/.test(window.location.search)) {
      var target = document.getElementById('tilmeld');
      if (target) target.scrollIntoView({ block: 'start' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme-editoren genindlæser sektioner uden at genindlæse siden.
  document.addEventListener('shopify:section:load', init);
})();
